'use client';

import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { FileIcon, TrashIcon, ArrowCircleUpIcon } from '@phosphor-icons/react/dist/ssr';
import { Text, Button } from '@/shared/ui/core';
import { truncateFilename } from '@/shared/lib/truncate-filename';
import styles from './loaded-file-item.module.scss';


type LoadedFileItemState = 'default' | 'uploading' | 'success' | 'error';


export interface LoadedFileItemProps
    extends HTMLAttributes<HTMLDivElement> {
    fileName: string;
    fileSize?: string;
    state?: LoadedFileItemState;
    onDelete?: () => void;
    onRetry?: () => void;
}


export function LoadedFileItem ({
    className,
    fileName,
    fileSize,
    state = 'default',
    onDelete,
    onRetry,
    ...props
}: LoadedFileItemProps) {
    return (
        <div
            className={ cn(styles.root, className) }
            { ...props }
        >
            <div className={ styles.title }>
                {
                    state !== 'error' &&
                    <FileIcon
                        size={ 20 }
                        className={ styles.icon }
                    />
                }
                {
                    state === 'error' &&
                    <Button
                        variant='naked'
                        onClick={ onRetry }
                        aria-label="An error occurred. Repeat upload"
                    >
                        <ArrowCircleUpIcon
                            size={ 20 }
                            className={ cn(styles.icon, styles.error) }
                        />
                    </Button>
                }

                <Text
                    size='md'
                    tone='primary'
                    weight='medium'
                    lineHeight={ 1.2 }
                    className={ styles.filename }
                >
                    { truncateFilename(fileName) }
                </Text>
            </div>

            <div className={ styles.actions }>
                {
                    fileSize &&
                    <Text
                        size='md'
                        tone='primary'
                        weight='medium'
                        lineHeight={ 1.2 }
                        className={ styles.size }
                    >
                        { fileSize }
                    </Text>
                }
                {
                    onDelete &&
                    <Button
                        variant='naked'
                        onClick={ onDelete }
                        aria-label="Delete file"
                    >
                        <TrashIcon size={ 20 }/>
                    </Button>
                }
            </div>
        </div>
    );
}
